import type { PermissionHookResult } from '../hooks/usePermissions';

/**
 * 判断页面是否拥有任意一个行内操作权限。
 */
export const hasAnyRowActionAccess = (
  permissions: PermissionHookResult,
  pageKey: string,
  actions: string[]
): boolean => actions.some(action => permissions.hasActionAccess(pageKey, action));

/**
 * 过滤操作列，避免用户没有任何行内操作权限时显示空操作列。
 */
export const filterActionColumnByAccess = <T extends { key?: string }>(
  columns: T[],
  hasActionColumnAccess: boolean
): T[] => columns.filter(column => column.key !== 'actions' || hasActionColumnAccess);
